import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ConfigurationService {

  // Observable string sources
  private configuration = new Subject<any>();
  private id_token = new Subject<string>();
  private user = new Subject<string>();
  private company_name = new Subject<string>();
  private premium = new Subject<boolean>();
  private type = new Subject<number>();
  private user_search = new Subject<boolean>();
  private role = new Subject<string>();
  private status = new Subject<number>();
  private errorHttp = new Subject<boolean>();

  // Observable string streams
  configuration$ = this.configuration.asObservable();
  id_token$ = this.id_token.asObservable();
  user$ = this.user.asObservable();
  company_name$ = this.company_name.asObservable();
  premium$ = this.premium.asObservable();
  type$ = this.type.asObservable();
  user_search$ = this.user_search.asObservable();
  role$ = this.role.asObservable();
  status$ = this.status.asObservable();
  errorHttp$ = this.errorHttp.asObservable();

  changeConfiguration(auth: any) {
    const keys = Object.keys(auth);
    for(let i=0;i<keys.length;i++){
      const key = keys[i];
      localStorage.setItem(key, auth[key]);
      this.configuration.next(auth);
    }
  }

  // Service message commands
  changeErrorHttp(errorHttp: boolean) {
    this.errorHttp.next(errorHttp);
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/services/configuration.service.ts